(function () {
    'use strict';

    angular
        .module('Controllers')
        .controller('DialogNewCtrl', DialogNewCtrl);

    function DialogNewCtrl(lodash, $timeout, close, dialogOptions, dialogAction, $scope, dialogModel, $http) {
        var vm = this;

        vm.dismiss = dismiss;
        vm.confirm = confirm;
        vm.initEvent = initEvent;
        vm.destroyEvents = destroyEvent;
        vm.addEvents = addEvents;
        vm.removeEvents = removeEvents;
        vm.setEvents = setEvents;
        vm.show = false;
        vm.options = dialogOptions;
        vm.eventRegistrationMap = {};
        vm.validation = {};

        initEvent();
        init();

        $scope.$on('$destroy', onDestroy);
        $timeout( function () {
            vm.show = true;
        } );

        function dismiss() {
            lodash.set(vm, 'data.model.confirm', false);
            close(vm.data, 250);
        }

        function confirm() {
            lodash.set(vm, 'data.model.confirm', true);
            close(vm.data, 250);
        }

        function init() {
            initDatasource();

            if (dialogModel != null) {
                var _model = lodash.get(vm.options, 'form.model', {});
                if (lodash.has(dialogModel, 'isMassSelectedItems') && dialogModel.isMassSelectedItems == true) {
                    _model = angular.extend({}, _model, dialogModel);
                } else {
                    var editModel = lodash.get(dialogModel, 'edit_model', {});
                    _model = angular.extend({}, _model, editModel);
                }
                lodash.set(vm.options, 'form.model', _model);
            }
        }

        function initDatasource() {
            if (lodash.has(dialogOptions, 'datasource')) {
                var _path = decodeURI(dialogOptions.datasource.url).replace(new RegExp('<id>', 'g'), dialogModel.id);
                $http.get(_path).then(function(res) {
                    vm.model = res.data;
                });
            }
        }

        function initEvent() {
            var defaultEvents = {
                'dialog.clear-modal': {
                    clearModal: {}
                },
                'dialog.close-dialog': {
                    closeDialog : {}
                }
            };

            var events = angular.merge(defaultEvents, vm.options.view_events);
            angular.forEach(events, function (actions, evtName) {
                vm.eventRegistrationMap[evtName] = $scope.$on(evtName, function (e, customEventData) {
                    dialogAction(actions, vm, e, customEventData, close);
                });
            });
        }

        function onDestroy() {
            destroyEvent();
        }

        function destroyEvent() {
            // important to destroy events, preventing memory leak
            angular.forEach(vm.eventRegistrationMap, function (evtDeregistration) {
                evtDeregistration();
            });
            vm.eventRegistrationMap = {};
        }

        function addEvents(events) {
            angular.forEach(events, function(actions, evtName) {
                if (lodash.has(vm.eventRegistrationMap, evtName)) {
                    vm.eventRegistrationMap[evtName]();
                    if (lodash.has(vm.eventRegistrationMap, evtName)) {
                        delete vm.eventRegistrationMap[evtName];
                    }
                    //lodash.unset(vm.eventRegistrationMap, evtName);
                }

                vm.eventRegistrationMap[evtName] = $scope.$on(evtName, function (e, customEventData) {
                    dialogAction(actions, vm, e, customEventData, close);
                });
            });
        }

        function setEvents(events) {
            destroyEvent();
            addEvents(events);
        }

        function removeEvents(events) {
            angular.forEach(events, function(evtName) {
                vm.eventRegistrationMap[evtName]();
                lodash.unset(vm.eventRegistrationMap, evtName);
            });
        }
    }
})();
